export { SalarySettingsTab } from './ui/SalarySettingsTab';
export type { SalarySettingsTabProps } from './ui/SalarySettingsTab';
export { SALARY_SETTINGS_LABEL } from './constants';
export { getSalaryFrameHost } from './utils/getSalaryFrameHost';
